var detectIE = function () {
  var ua = window.navigator.userAgent // eslint-disable-line no-undef

  var msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  var edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

if (detectIE() === false || detectIE() >= 12) {
  let elements = document.querySelectorAll('[ref="ie11"]')
  elements.forEach(function (element) {
    element.style.display = 'none'
  })
} else {
  let elements = document.querySelectorAll('[ref="modernBrowser"]')
  elements.forEach(function (element) {
    element.style.display = 'none'
  })
}



// WEBPACK FOOTER //
// ./assets/js/detect-ie.js